import { alert_add } from 'comps'

import { Component, Show, createEffect, createMemo } from 'solid-js'
import { createStore } from 'solid-js/store'

import { Gene } from 'api'

import { hex_le } from './utils'

type GeneDpyProps = {
    gene: Gene | null
    onClick?(gene: Gene): void
}
export const GeneDpy: Component<GeneDpyProps> = P => {
    type State = {
        id: number
        invalid: boolean
    }
    const [state, setState] = createStore<State>({
        id: 0,
        invalid: false,
    })

    createEffect(() => {
        if (!P.gene) {
            setState({ id: 0, invalid: false })
            return
        }
        if (P.gene.length != 32) {
            setState({ id: 0, invalid: true })
            return
        }
        let id = hex_le(P.gene.slice(0, 16))
        if (id == null) {
            setState({ id: 0, invalid: true })
            return
        }
        // let pepper = hex_le(gene.slice(18, 18 + 6))
        setState({ id, invalid: false })
    })

    function onClick() {
        if (state.invalid) {
            navigator.clipboard.writeText(P.gene + '')
            alert_add({
                subject: 'invalid gene was copied',
                timeout: 3,
                type: 'info',
                content: P.gene + '',
            })
            return
        }

        if (P.onClick && P.gene) P.onClick(P.gene)
    }

    return (
        <button
            class='styled gene-dpy'
            disabled={state.id == 0 && !state.invalid}
            onclick={onClick}
        >
            Gene(
            <Show
                when={!state.invalid}
                fallback={<span class='invalid'>INVALID</span>}
            >
                <Show
                    when={state.id != 0}
                    fallback={<span class='empty'>---</span>}
                >
                    <NumDpy num={state.id} />
                </Show>
            </Show>
            )
        </button>
    )
}

type NumDpyProps = {
    num: number
}
export const NumDpy: Component<NumDpyProps> = P => {
    type State = {
        sec: string[]
    }
    const [state, setState] = createStore<State>({
        sec: [],
    })

    createEffect(() => {
        setState({ sec: P.num.toLocaleString().split(',') })
    })

    return (
        <span class='num-dpy'>
            {state.sec.map((p, i, a) => (
                <>
                    {p}
                    <Show when={i + 1 != a.length}>
                        <span class='comma'>,</span>
                    </Show>
                </>
            ))}
        </span>
    )
}

type BoolDpyProps = {
    value: boolean
}
export const BoolDpy: Component<BoolDpyProps> = P => {
    return (
        <span class='bool-dpy' classList={{ true: P.value, false: !P.value }}>
            {P.value + ''}
        </span>
    )
}

type TimeDpyProps = {
    ts: number
}
export const TimeDpy: Component<TimeDpyProps> = P => {
    let date_time = createMemo(() => {
        let dt = new Date(P.ts * 1e3)
        return dt.toLocaleString()
    })

    let dpy = createMemo(() => {
        if (P.ts == 0) return '---'
        
        let now = ~~(new Date().getTime() / 1e3)
        if (P.ts == now) return 'now'

        if (P.ts > now) return 'this happend in the future 😐'

        let delta = now - P.ts
        if (delta > 7 * 24 * 3600) {
            let dt = new Date(P.ts * 1e3)
            let y = dt.getFullYear()
            let m = dt.getMonth().toString().padStart(2, '0')
            let d = dt.getDate().toString().padStart(2, '0')
            return `${y}/${m}/${d}`
        }

        if (delta >= 24 * 3600) {
            let days = ~~(delta / (24 * 3600))
            if (days == 1) return 'a day ago'
            return `${days} days ago`
        }

        if (delta >= 3600) {
            let hours = ~~(delta / 3600)
            let m = ~~((delta % 3600) / 60)
            let mm = ''
            if (m == 1) mm = ' and a minute'
            else if (m > 1) mm = ` and ${m} minutes `

            if (hours == 1) return `an hour${mm} ago`
            return `${hours} hours${mm} ago`
        }

        if (delta >= 60) {
            let m = ~~(delta / 60)
            if (m == 1) return 'a minute ago'
            return `${m} minutes ago`
        }

        if (delta == 1) return 'a second ago'

        return `${delta} seconds ago`
    })

    return (
        <span class='time-dpy' title={date_time()}>
            {dpy()}
        </span>
    )
}
